<prizm-icon [iconClass]="prizmInputIconButton" [size]="size"></prizm-icon>
